import { compressAccurately } from 'image-conversion';

const MAX_SIZE_KB = 300;
const MAX_WIDTH = 1920;

/**
 * Compresses an image to WebP under 300KB before upload.
 * @param {File} file - Original image from device
 * @returns {Promise<Blob>} WebP blob ready for upload
 */
export async function compressWorkPhoto(file) {
	if (!file || !file.type.startsWith('image/')) {
		throw new Error('Please select a valid image file');
	}

	const compressed = await compressAccurately(file, {
		size: MAX_SIZE_KB,
		accuracy: 0.92,
		type: 'image/webp',
		width: MAX_WIDTH,
	});

	return compressed;
}
